export const emailPattern =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const mobilePattern =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

export const datePattern =
  /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

export const positiveNumberPattern = /^\d+\.?\d*$/;

export const nameJustCharacterPattern =
  /[0-9\u06F0-\u06F9@!#\$\^%&*`()~÷«»٬٫﷼٪×،ـ؛؟+=\-\[\]\\\';,\.\/\{\}\|\":<>\?]+$/g;

export const englishOrPersianCharacter = /^[a-zءA-Zآ-ی\s]+$/;

export const englishCharacter = /^[a-zA-Z ]+$/;

export const farsiSpecialChar = /[٬٫﷼٪×،*؟،*)(]+$/;
export const urlPattern =
  /^(https?|http):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;

export const svgFileUrlPattern = /\.svg(\?|#|$)/i;
